<div class="col-md-12 col-sm-12 col-12 padding-R5 myprofile_flex_items padding-right40" id="myProfilepage">
  @if (memberDetails; as item) {
    <div class="myprofile_membership">
      <div class="row">
        <div class="col-md-8 col-sm-8 col-8">
          <div class="myprofile_tophybrisheader">{{"membership.title" | cxTranslate}}</div>
        </div>
        @if (item?.membershipStatus=='Active') {
          @if (!toggleEdit) {
            <div class="col-md-3 col-sm-4 col-4" (click)="edit()">
              <div class="myprofilemember_editbtn" id="myprofilemember_editbtn">{{"profile.editlabel" | cxTranslate}}<img src="/assets/images/edit.png" width="20" alt="Edit"></div>
            </div>
          }
        }
      </div>
      <div class="myprofile_view-membership">
        <div class="row margin-T20">
          <div class="col-md-5 col-sm-6 col-xs-12">
            <div class="myprofile_hybrisheader">{{"membership.header" | cxTranslate}}</div>
            @if (item?.membershipStatus=='Pending') {
              <span class="myprofile_hybrisheader_txt myprofile_membership-num">{{item?.requestedMembership}}</span>
            } @else {
              <span class="myprofile_hybrisheader_txt myprofile_membership-num">{{item?.currentMembership}}</span>
            }
            <!-- Membership for My profile page-->
          </div>
          <div class="col-md-7 col-sm-6 col-xs-12">
            <div class="myprofile_hybrisheader myprofile_Mobile-status">{{"membership.status" | cxTranslate}}</div>
            <span
            class="myprofile_hybrisheader_txt myprofile_membership-status">{{item?.membershipStatus}}</span>
            <!-- Membership for My profile page-->
          </div>
          @if (item?.membershipStatus=='Pending') {
            <div class="col-md-12 col-sm-12 col-xs-12 margin-T20"> <!-- to be shown if status is pending -->
              <div class="myprofile_membership-PendingText" [innerHTML]="'membership.pendingmsg' | cxTranslate">
              </div>
            </div>
          }
          <div class="col-md-12 col-sm-12 col-xs-12 margin-T20 pendingtextcontainer">
            <!-- to be shown if status is pending hidden from less and showing on click of submit-->
            <!-- <div class="myprofile_membership-PendingText">Your membership is currently being reviewed and will be validated in 1-2 business days. Please contact <a href="mailto:customerservice.us@seqirus.com">flu360 Customer Service</a> with any questions.</div> -->
          </div>
        </div>
      </div>
      @if (toggleEdit) {
        <div class="myprofile_editview-membership">
          <form id="myprofile_memberform" [formGroup]="seqirusMemberShipVisibilityForm" method="post">
            <div class="col-xs-12 cart_questionheader">{{"membership.qstn" | cxTranslate}}
            </div>
            <div class="col-xs-12 membership_subheader"><!-- {{"membership.subtext" | cxTranslate}}  -->
            </div>
            <div class="col-xs-12 memberradiocontainer">
              <input (click)="toggleMemberDecision('yes')" formControlName="membershipDecision" type="radio"  name="membershipDecision" class="memberradiobtn" id="memberradiobtn1"
                value="yes">
                <span class="radio-button__control"></span>
                <label for="memberradiobtn1">{{"membership.yesmsg" | cxTranslate}}</label>
              </div>
              <div class="col-xs-12 memberradiocontainer">
                <input (click)="toggleMemberDecision('no')" formControlName="membershipDecision" type="radio" name="membershipDecision" class="memberradiobtn" id="memberradiobtn2"
                  value="no">
                  <span class="radio-button__control"></span>
                  <label for="memberradiobtn2">{{"membership.nomsg" | cxTranslate}}</label>
                </div>
                <div class="col-md-9 col-xs-11 addmemberfield">
                  <label class="cartmember_inputLabel" for="memberinput">{{"membership.BuyingGroup" | cxTranslate}}</label>
                  <input  formControlName="memberinput" class="cartmember_input form-control" id="memberinput" name="requestedMembership"
                    placeholder="Enter Buying Group Organization Name" autocomplete="no" (keyup)="togglesubmit()">
                    @if (seqirusMemberShipVisibilityForm.controls['memberinput'].invalid && (seqirusMemberShipVisibilityForm.controls['memberinput'].touched || seqirusMemberShipVisibilityForm.controls['memberinput'].dirty)) {
                      <div class="text-danger">
                        @if (seqirusMemberShipVisibilityForm.controls['memberinput'].errors?.['pattern']) {
                          <div class="membererrortext"><i class="fa-solid fa-circle-exclamation"></i>{{"membership.errormsgbuyinggroup" | cxTranslate}}</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="clearboth"></div>
                  <div class="col-xs-12 memberradiocontainer">
                    <input (click)="toggleMemberDecision('notsure')" formControlName="membershipDecision" type="radio" name="membershipDecision" class="memberradiobtn" id="memberradiobtn3"
                      value="notsure">
                      <span class="radio-button__control"></span>
                      <label for="memberradiobtn3">{{"membership.notsurelabel" | cxTranslate}}</label>
                    </div>
                    <div class="clearboth"></div>
                    <div class="row margin-T30">
                      <div class="col-md-5 col-sm-6 col-xs-12"> </div>
                      <div class="col-md-7 col-sm-6 col-xs-12">
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                          <button type="button" class="myprofile_cancel" id="myprofilemember_cancel" (click)="edit()">{{"profile.cancellabel" | cxTranslate}}</button>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                          <button [disabled]="submitenable" (click)="submit()" type="button" class="myprofile_submit" id="myprofilemember_submit">{{"profile.submitlabel" | cxTranslate}}</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              }
            </div>
          }
        </div>